import { useState } from "react";
// import "./modal.css";

const Modal = ({ buttonLabel, buttonClassName, children, successFunction }) => {
  const [isOpen, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  const handleSubmit = async (e) => {
    if (successFunction) await successFunction(e);
    onClose();
  };

  return (
    <>
      <button
        type="button"
        className={buttonClassName}
        onClick={() => setOpen(true)}
      >
        {buttonLabel}
      </button>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close-button" onClick={onClose}>
              &times;
            </button>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              <button className="modal-cancel-button" onClick={onClose}>
                Cancel
              </button>
              <button className="modal-submit-button" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
